import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import PDF from "../../../../src/content/images/Discussion-questions.pdf";
import * as React from 'react';
export default {
  getImage,
  GatsbyImage,
  PDF,
  React
};